import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import useQueryParams from '../../../../hooks/useQueryParams';
import style from './LoginFooter.module.scss';

const LoginFooter = ({ hideSignupLink = false }) => {
  const { totpsetup } = useQueryParams();
  const isSetPassword = useRouteMatch(['/new-password', '/recover', '/signup']);

  return (
    <div>
      <ul className={style.footerMenu}>
        <li className={style.footerMenuItem}>
          <a
            className={style.footerMenuLink}
            href="https://help.chaserhq.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Help Centre
          </a>
        </li>
        <li className={style.footerMenuItem}>
          <a className={style.footerMenuLink} href="mailto:support@chaserhq.com">
            Support
          </a>
        </li>
        {!isSetPassword && !totpsetup && !hideSignupLink && (
          <li className={style.footerMenuItem}>
            <a
              className={style.footerMenuLink}
              href="https://www.chaserhq.com/signup"
              target="_blank"
              rel="noopener noreferrer"
            >
              Sign up to Chaser
            </a>
          </li>
        )}
      </ul>
    </div>
  );
};

export default LoginFooter;
